import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { background } = theme.palette;
  const { sm } = theme.breakpoints;
  const { spacing } = theme;

  const customBreakpoint = 1439;

  const componentWrapper = css`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0;
    background: ${background.darkBlue};
    display: grid;
    grid-template-columns: 1fr 832px;

    @media (max-width: ${`${customBreakpoint}px`}) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `;

  const componentContent = css`
    padding: ${spacing(4, 2, 3, '87px')};

    & h3 {
      color: white;
      margin-bottom: ${spacing(2)};

      @media (max-width: ${`${customBreakpoint}px`}) {
        text-align: center;
      }
    }

    @media (max-width: ${`${customBreakpoint}px`}) {
      padding: ${spacing(4, 2)};
    }
  `;

  const componentRows = css`
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};

    & [data-hovered='true'] {
      transform: translateX(-20px);

      @media (max-width: ${`${customBreakpoint}px`}) {
        transform: translateX(0px);
      }
    }
  `;

  const componentRowWrapper = css`
    display: flex;
    gap: ${spacing(1)};
    align-items: center;

    & img {
      display: none;

      @media (max-width: ${`${customBreakpoint}px`}) {
        display: block;
        height: max-content;
        object-fit: contain;
        width: 75px;
      }
    }

    @media (max-width: ${`${customBreakpoint}px`}) {
      width: 100%;
      max-width: 530px;
      margin: 0 auto;
    }
  `;

  const largeRowWrapper = css`
    @media (max-width: ${`${customBreakpoint}px`}) {
      flex-direction: column;
      align-items: center;
      text-align: center;

      & img {
        width: 100%;
        max-width: 300px;
        margin-bottom: ${spacing(1)};
      }

      & p {
        width: 100%;
        max-width: 440px;
      }
    }
    @media (max-width: ${`${sm}px`}) {
      text-align: left;
    }
  `;

  const componentRow = css`
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: all 0.25s ease;

    & h4,
    p {
      color: white;
    }

    & p {
      font-weight: 300;
    }
  `;

  const ctaStyle = css`
    width: 100%;
    max-width: 290px;
    margin-top: ${spacing(3)};
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};

    & > button {
      max-width: 290px;
    }

    & > p {
      margin: 0;
      font-size: 14px;
      line-height: 14px;
      font-weight: 300;
      text-align: center;
      color: white;
    }

    @media (max-width: ${`${customBreakpoint}px`}) {
      margin: ${spacing(3, 'auto', 0)};
    }
  `;

  const componentImage = css`
    width: 100%;
    max-width: 833px;
    aspect-ratio: 833 / 912;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;

    & [data-hovered='true'] {
      opacity: 1;
    }

    @media (max-width: ${`${customBreakpoint}px`}) {
      display: none;
    }
  `;

  const hoverImageStyle = css`
    position: absolute;
    opacity: 0.7;
    transition: opacity 0.25s ease;
  `;

  const staticImageStyle = css`
    width: 100%;
  `;

  return {
    componentWrapper,
    componentContent,
    componentRows,
    componentRowWrapper,
    largeRowWrapper,
    componentRow,
    ctaStyle,
    componentImage,
    hoverImageStyle,
    staticImageStyle,
  };
};

export default useStyle;
